module.exports = __webpack_public_path__ + "img/SA-tab.19d553f2.jpg";